// extracted by mini-css-extract-plugin
module.exports = {"blockquotes":"styles_blockquotes__MDCXM","blockquotes__carousel":"styles_blockquotes__carousel__rp855","blockquotes__card":"styles_blockquotes__card__oXiMY"};